exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titulo {\n  font-size: 70px; }\n\n.subtitulo {\n  font-size: 30px; }\n\n.posicao-cor {\n  text-align: center;\n  color: #405b76; }\n\n.paragrafo {\n  padding: 0 40px 0 40px;\n  font-size: 16px; }\n\n.lista {\n  font-size: 18px;\n  padding: 0 80px 0 80px; }\n\n.itemBorder {\n  border: 3px solid rgba(28, 110, 164, 0.5);\n  border-radius: 0px 10px 10px 10px;\n  margin-left: 120px;\n  margin-right: 120px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/fabiano/git/assinador-showcase/frontend/src/app/home/home.component.scss
// module id = ../../../../../src/app/home/home.component.scss
// module chunks = main